import moment from "moment";

export const statuses = [
  { title: "Active", value: 0, hexCode: "#28a745", sortValue: 3, sortValue2: 1 },
  { title: "Inactive", value: 1, hexCode: "#ffc107", sortValue: 2, sortValue2: 2 },
  { title: "Offline", value: 2, hexCode: "#dc3545", sortValue: 1, sortValue2: 3 },
  { title: "Out of Operational Hours", value: 3, hexCode: "", sortValue: 4, sortValue2: 4 },
];

const days = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];
export const time_in_between = (beforeTime, afterTime) => {
  var format = "hh:mm:ss";

  // var time = moment() gives you current time. no format required.
  // var time = moment(new Date(), format);
  // if (time.isBetween(moment(beforeTime, format), moment(afterTime, format))) {
  //   return true;
  // } else {
  //   return false;
  // }
  var isTimeValid = false;
  var startTime = moment(beforeTime, format);
  var midnight = moment('12:00 AM', format);
  var endTime = moment(afterTime, format);
  var inputtedTime = moment(new Date(), format);

  if (endTime.isBefore(startTime)) {
    if (inputtedTime.isBetween(midnight, endTime, null, '[]')) {
      inputtedTime.add(1, 'days');
      // console.log("adjusted input time to next day");
    }

    endTime.add(1, 'days');
    // console.log("adjusted end time to next day");
  }

  // console.log(inputtedTime.format());
  // console.log(startTime.format());
  // console.log(endTime.format());

  isTimeValid = inputtedTime.isBetween(startTime, endTime);
  // console.log(isTimeValid); // between start and end
  if (isTimeValid) {
    return true;
  } else {
    return false;
  }
};
export const isInOperationalHours = (sessionData, todaysTimings) => {
  if (sessionData?.are_you_open_24_x_7) return true;
  else {
    const day = days[new Date().getDay()];
    let _todays_timings = {
      closesAt: "",
      timings: [],
      opensAt: "",
    };
    let is_in_op_hours = false;
    if (sessionData[day]?.multipleHours?.length && sessionData[day]?.open) {
      sessionData[day].multipleHours.forEach((element) => {
        let openTime = moment(element.opening_time).format("hh:mm A");
        let closeTime = moment(element.closing_time).format("hh:mm A");
        let getOpenHours = new Date(element.opening_time).getHours();
        let getOpenMinutes = new Date(element.opening_time).getMinutes();
        let getCloseHours = new Date(element.closing_time).getHours();
        let getCloseMinutes = new Date(element.closing_time).getMinutes();

        let open = moment(new Date().setHours(0, 0, 0, 0))
          .add(getOpenHours, "hours")
          .add(getOpenMinutes, "minutes");
        let close = moment(new Date().setHours(0, 0, 0, 0))
          .add(getCloseHours, "hours")
          .add(getCloseMinutes, "minutes");

        element.open_dateTime = open;
        element.close_dateTime = close;
        element.openTime = openTime;
        element.closeTime = closeTime;
        _todays_timings.opensAt = openTime;
        _todays_timings.closesAt = closeTime;
        _todays_timings.timings.push(`${openTime + " - " + closeTime}`);
        if (time_in_between(open, close)) is_in_op_hours = true;
      });
      if (todaysTimings) {
        todaysTimings(_todays_timings);
      }
      return is_in_op_hours;
    }
    return false;
  }
};

export function getBusinessTimingsStatus(MainData) {
  if (isInOperationalHours(MainData)) {
    if (MainData?.sessionSettings?.restaurant_open) {
      if (MainData?.isLoggedIn) return statuses[0];
      else return statuses[1];
    } else {
      if (MainData?.isLoggedIn) return statuses[2];
      else return statuses[2];
    }
  } else {
    return statuses[3];
    // if (MainData?.sessionSettings?.restaurant_open) {
    //   if (MainData?.isLoggedIn) return statuses[0];
    //   else return statuses[2];
    // } else {
    //   if (MainData?.isLoggedIn) return statuses[2];
    //   else return statuses[3];
    // }
  }

  // if (
  //   isInOperationalHours(MainData) &&
  //   MainData?.sessionSettings?.restaurant_open &&
  //   MainData?.isLoggedIn
  // ) {
  //   // Outlet is Logged IN and Session settings ON & It is in the Operational Hours
  //   return statuses[0];
  // } else if (
  //   isInOperationalHours(MainData) &&
  //   MainData?.sessionSettings?.restaurant_open &&
  //   !MainData?.isLoggedIn
  // ) {
  //   // Outlet is Logged OUT and Session settings ON & It is in the Operational Hours
  //   return statuses[1];
  // } else if (
  //   isInOperationalHours(MainData) &&
  //   !MainData?.sessionSettings?.restaurant_open &&
  //   !MainData?.isLoggedIn
  // ) {
  //   // Outlet is Logged OUT and Session settings OFF & It is in the Operational Hours
  //   return statuses[2];
  // } else if (
  //   !isInOperationalHours(MainData) &&
  //   !MainData?.sessionSettings?.restaurant_open &&
  //   !MainData?.isLoggedIn
  // ) {
  //   // The Outlet is out of its Operational Hours
  //   return statuses[3];
  // } else return statuses[3];
}
